"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = exports.ConsoleLogger = void 0;
var console_logger_1 = require("./console.logger.cjs");
Object.defineProperty(exports, "ConsoleLogger", { enumerable: true, get: function () { return console_logger_1.ConsoleLogger; } });
var logger_1 = require("./logger.cjs");
Object.defineProperty(exports, "Logger", { enumerable: true, get: function () { return logger_1.Logger; } });
